/**
 * Helpers para shipping_expenses.file (único string o array según ModelDefinition).
 */

function firstFileKeyFromValue(file) {
  if (file == null || file === "") return null;
  if (typeof file === "string") {
    const s = file.trim();
    return s || null;
  }
  if (Array.isArray(file)) {
    for (const entry of file) {
      const k = firstFileKeyFromValue(entry);
      if (k) return k;
    }
    return null;
  }
  if (typeof file === "object") {
    if (typeof file.path === "string" && file.path.trim()) return file.path.trim();
    if (typeof file.fileKey === "string" && file.fileKey.trim()) return file.fileKey.trim();
    if (typeof file.url === "string" && file.url.trim()) return file.url.trim();
    if (file._id != null) return String(file._id);
  }
  return null;
}

/**
 * Valor para FieldFile (string o array de keys según isArray).
 */
export function fileRefValueFromExpenseDoc(file, isArray = false) {
  if (file == null || file === "") return isArray ? [] : null;
  if (isArray) {
    const keys = [];
    const visit = (entry) => {
      if (entry == null || entry === "") return;
      if (typeof entry === "string") {
        const s = entry.trim();
        if (s && !keys.includes(s)) keys.push(s);
        return;
      }
      if (Array.isArray(entry)) {
        entry.forEach(visit);
        return;
      }
      if (typeof entry === "object") {
        const k = firstFileKeyFromValue(entry);
        if (k && !keys.includes(k)) keys.push(k);
      }
    };
    visit(file);
    return keys.length ? keys : [];
  }
  return firstFileKeyFromValue(file);
}

/**
 * Serializa el valor del formulario para PUT/POST de shipping_expenses.
 */
export function serializeExpenseFileForApi(fileRefValue, isArray = false) {
  if (isArray) {
    const keys = [];
    const visit = (entry) => {
      if (entry == null || entry === "") return;
      if (typeof entry === "string") {
        const s = entry.trim();
        if (s && !keys.includes(s)) keys.push(s);
        return;
      }
      if (Array.isArray(entry)) {
        entry.forEach(visit);
        return;
      }
      if (typeof entry === "object" && entry._id != null) {
        const s = String(entry._id).trim();
        if (s && !keys.includes(s)) keys.push(s);
      }
    };
    visit(fileRefValue);
    return keys.length ? keys : null;
  }
  if (fileRefValue == null || fileRefValue === "") return null;
  if (typeof fileRefValue === "string") {
    const s = fileRefValue.trim();
    return s || null;
  }
  if (typeof fileRefValue === "object" && fileRefValue._id != null) {
    return String(fileRefValue._id);
  }
  return firstFileKeyFromValue(fileRefValue);
}

export function fileFieldDefFromShippingDefinition(shippingFields) {
  const fields = Array.isArray(shippingFields) ? shippingFields : [];
  const expensesG = fields.find((f) => f && f.key === "expenses" && f.type === "group");
  const inner = Array.isArray(expensesG && expensesG.fields) ? expensesG.fields : [];
  const fileF = inner.find((f) => f && f.key === "file" && f.type === "file");
  const isArray = !!(fileF && fileF.isArray);
  return {
    type: "file",
    key: "file",
    label: (fileF && fileF.label) || "File",
    isArray,
    readonly: false,
    required: false,
    hide: false,
    safe: false,
    accept: "*",
  };
}
